import { ApiState, PassValidationCompStatus } from "../../common/constants/api-constants";

export declare interface Persona {
  segment: string;
  role: string;
}

export declare interface UserAffiliation {
  department?: string;
  discipline?: string;
  jobTitle?: string;
  orgCountry: string;
  orgCity: string;
  orgName: string;
  orgXid: string;
  orgState?: string;
  role: string;
  segment: string;
}

export declare interface School {
  id?: string;
  name?: string;
  xid?: string;
  segment?: string;
  address?: SchoolAddress;
}

export declare interface SchoolAddress {
  line1?: string;
  city?: string;
  state?: string;
  country?: string;
}

export declare interface UserSource {
  externalId: string;
  sourceId: string;
  sourceName: string;
}

export enum UserStatus {
  active = 'ACTIVE',
  pending = 'PENDING',
  inactive = 'INACTIVE',
}

export declare interface UserProfile {
  affiliations: Array<UserAffiliation>;
  email: string;
  familyName: string;
  givenName: string;
  phone: string;
  question: string;
  sources: Array<UserSource>;
  status?: UserStatus;
  userType: string;
  xid: string;
  persona: Persona;
  isSelfOptOutEnabled: Boolean;
}

export declare interface UserState {
  user: {
    data?: UserProfile;
    isLoading: boolean;
    isLoaded: boolean;
    isSuccess: boolean;
    isFailure: boolean;
    message: string;
  };
}

export declare interface SecurityQuestion {
  questionText: string;
}
export declare interface GetSecurityQuestionState extends ApiState {
  data: SecurityQuestion[];
}

export declare interface GetSchoolState extends ApiState {
  data: SchoolResponse;
  signal?: AbortController
}

export declare interface SchoolResponse {
  content: School[];
  start: number;
  size: number;
  totalElements: number;
}

export declare interface GetSchoolByIdState extends ApiState {
  data: School[];
}

export declare interface GetDepartmentState extends ApiState {
  data: {
    id: number;
    name: string;
  }[];
}

export declare interface GetDesciplineState extends ApiState {
  data: {
    id: number;
    name: string;
  }[];
}

export declare interface UserProfileState {
  userProfileResponse: GetUserProfileState;
  updateProfile: {
    passCompState: PassValidationCompStatus;
    updateUserProfileResponse: ApiState;
    password: string;
    uniqueEmailState: ApiState;
    schoolResponse: GetSchoolState;
    schoolByIdResponse: GetSchoolByIdState;
    departmentCache: Record<string, GetDepartmentState>;
    desciplineResponse: GetDesciplineState;
    affiliations: UserAffiliation[];
  };
  selfCall: ApiState;
  securityQuestionResponse: GetSecurityQuestionState;
  signoutResponse: ApiState;
}

export declare interface GetUserProfileState extends ApiState {
  data: UserProfile;
}

export declare interface UserPayload extends UserProfile {
  hasAgreedTerms?: boolean;
  isLMSFlow: boolean;
  newPassword: string;
  confirmNewPassword: string;
  password: string;
}

export interface FetchUserParams { 
  forceUpdate?: boolean;
  checkSelfOptOut?: boolean;
}